import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ManagePets from './pages/ManagePets';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/manage-pets" element={<ManagePets />} />
      </Routes>
    </Router>
  );
}

export default App;
